export default __webpack_public_path__ + "static/media/8028-brazy.b3607273.pdf";